/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Listado from 'components/public/Listado/Listado';
import { titulosListadoTalleres } from 'utils/constants';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { fetchTalleres } from 'utils/redux/features/talleresSlice';
import { TallerBase, TallerListado } from 'utils/models/types';
import { convertirFechasAHorarios, convertirFechasStringAFechas, formatearFechaParaListado } from 'utils/utilities';
import Spinner from 'components/public/Spinner/Spinner';

const Talleres = () => {
  const { talleres, loadingTalleres, errorTalleres } = useSelector((state: RootState) => state.talleres);

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchTalleres());
  }, [dispatch]);

  const onAgregar = () => {
    navigate(`/admin/alta-taller`);
  };

  const talleresListado: TallerBase[] = talleres.map((t: TallerListado) => {
    const horariosClasesEnDate = t.HorariosClases && t.HorariosClases.map(fecha => convertirFechasStringAFechas(fecha));
    const horariosFormateados = convertirFechasAHorarios(horariosClasesEnDate);
    const fechaInicio = t.HorariosClases && t.HorariosClases[0]?.FechaInicio;
    const fechaFin = t.HorariosClases && t.HorariosClases[t.HorariosClases.length - 1]?.FechaInicio;
    return {
      ...t,
      FechaInicio: fechaInicio && formatearFechaParaListado(fechaInicio),
      FechaFin: fechaFin && formatearFechaParaListado(fechaFin),
      ValorCuota: `$${t.ValorCuota}`,
      VisibleEnGrilla: t.VisibleEnGrilla ? 'Sí' : 'No',
      Dias: horariosFormateados || '',
      Programa: 'Ver inscriptos',
      DetallePath: `/admin/talleres/${t.Id}/inscriptos`,
    };
  });

  const onEditar = (id: number) => {
    navigate(`/admin/talleres/${id}`);
  };
  const error401 = errorTalleres?.includes('permisos');

  return loadingTalleres ? (
    <Spinner />
  ) : errorTalleres ? (
    error401 ? (
      <NotAllowed />
    ) : (
      <NoResponse />
    )
  ) : (
    <Listado
      lista={talleresListado}
      headCells={titulosListadoTalleres}
      titulo="Gestionar talleres"
      onAgregar={onAgregar}
      onEditar={onEditar}
      loading={loadingTalleres}
    />
  );
};

export default Talleres;
